import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import FontAwesome from 'react-fontawesome'
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import AuditoriaAlocacaoMOTStore from "../stores/AuditoriaAlocacaoMOTStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {formatarCPF, formatarData, formatarPercentual} from "../../../utils/functions";

const FILTROS = ["AREA", "DIVISAO", "CPF", "MOT", "COMPETENCIA"];
const VALIDACOES = ["COMPETENCIA_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class AuditoriaAlocacaoMOT extends Component {
    constructor(props) {
        super(props);
        this.controller = new AuditoriaAlocacaoMOTStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Auditoria alocação de MOTs");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                controller={this.controller}
                                history={this.props.history}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACOES}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)}
                                onExportPdf={(filtro) => this.controller.onExportPdf(filtro)} />
                        { this.controller.dados && this.controller.dados.length > 0 && !this.controller.erro &&
                            <BootstrapTable ref='table' version='4' data={this.controller.dados} striped hover pagination search condensed searchPlaceholder="Pesquisar">
                                {
                                    COLUMNS.map(column =>
                                        <TableHeaderColumn columnTitle { ...column } >
                                            { column.label }
                                        </TableHeaderColumn>
                                    )
                                }
                            </BootstrapTable>
                        }
                        {this.controller.erro &&
                            <MensagemErro>
                                {this.controller.erro}
                            </MensagemErro>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}

const COLUMNS = [
    { key: "1", label: "Número solicitação", dataField: "id", width: "150", dataSort: true, isKey: true },
    { key: "2", label: "N1", dataField: "area", width: "200", dataSort: true },
    { key: "3", label: "N2", dataField: "central", width: "200", dataSort: true },
    { key: "4", label: "N3", dataField: "divisao", width: "200", dataSort: true },
    { key: "5", label: "N4", dataField: "departamento", width: "200", dataSort: true },
    { key: "6", label: "Unidade de negócio (BU)", dataField: "empresa", width: "200", dataSort: true },
    { key: "7", label: "Gestor responsável", dataField: "gestorResponsavel", width: "200", dataSort: true },
    { key: "8", label: "Local de trabalho", dataField: "localTrabalho", width: "200", dataSort: true },
    { key: "9", label: "CPF", dataField: "cpf", width: "100", dataSort: true, dataFormat: formatarCPF },
    { key: "10", label: "Nome", dataField: "nome", width: "200", dataSort: true },
    { key: "11", label: "Cargo", dataField: "cargo", width: "200", dataSort: true },
    { key: "12", label: "Motivo", dataField: "motivo", width: "200", dataSort: true },
    { key: "13", label: "Justificativa", dataField: "justificativa", width: "200", dataSort: true },
    { key: "14", label: "Projeto/centro de resultado/finalidade", dataField: "produto", width: "200", dataSort: true },
    { key: "15", label: "Admissão", dataField: "admissao", width: "200", dataSort: true, dataFormat: formatarData },
    { key: "16", label: "Término contrato", dataField: "terminoContrato", width: "200", dataSort: true, dataFormat: formatarData },
    { key: "17", label: "Dia início alocação", dataField: "diaInicioAlocacao", width: "200", dataSort: true, dataFormat: formatarData },
    { key: "18", label: "Dia fim alocação", dataField: "diaFimAlocacao", width: "200", dataSort: true, dataFormat: formatarData },
    { key: "19", label: "Projeto/centro de resultado/finalidade alocação", dataField: "produtoAlocacao", width: "200", dataSort: true },
    { key: "20", label: "% alocação", dataField: "percentualAlocacao", width: "100", dataSort: true, dataFormat: formatarPercentual },
];